import React from 'react';

export default () => (
    <svg
        width="482"
        height="302"
        viewBox="0 0 482 302"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect
            x="1"
            y="1"
            width="480"
            height="300"
            rx="3.85542"
            stroke="#B2B2B2"
            strokeLinecap="round"
            strokeDasharray="8 8"
        />
    </svg>
);
